import { createAction, props } from '@ngrx/store';
import { ApplicationUserDetail } from '../../models/application-user-detail.model';
import { AddEditRacf } from '../../models/add-edit-racf.model';
import { CustomerUserAgent } from '../../models/customer-user-agent.model';

export const loadActiveBusinessUnits = createAction(
    '[User Management] Load Active Business Units'
);

export const loadActiveRoles = createAction(
    '[User Management] Load Active Roles'
);

export const loadActiveTeams = createAction(
    '[User Management] Load Active Teams'
);

export const loadUserDetail = createAction(
    '[User Management] Load User Detail',
    props<{ userId: number }>()
);

export const resetUserManagement = createAction(
    '[User Management] Reset User Management'
);

export const toggleShowAllBusinessUnits = createAction(
    '[User Management Business Units] Toggle Show All Business Units'
);

export const toggleShowAllRoles = createAction(
    '[User Management Roles] Toggle Show All Roles'
);

export const toggleShowAllTeams = createAction(
    '[User Management Teams] Toggle Show All Teams'
);

export const updateUserInfo = createAction(
    '[User Management User Info] Update User Info',
    props<{ userDetail: ApplicationUserDetail }>()
);

export const toggleSelectedBusinessUnit = createAction(
    '[User Management Business Units] Toggle Selected Business Unit',
    props<{ id: number; selected: boolean }>()
);

export const togglePrimaryBusinessUnit = createAction(
    '[User Management Business Units] Toggle Primary',
    props<{ id: number }>()
);

export const toggleFieldBusinessUnits = createAction(
    '[User Management Business Units] Toggle Field Business Units',
    props<{ selected: boolean }>()
);

export const updateSelectedRoles = createAction(
    '[User Management Roles] Toggle Selected Role',
    props<{ roleIds: number[] }>()
);

export const updateSelectedTeams = createAction(
    '[User Management Teams] Toggle Selected Team',
    props<{ teamIds: number[] }>()
);

export const setInProgress = createAction(
    '[User Management] Set In Progress',
    props<{ inProgress: boolean }>()
);

export const setIsFormValid = createAction(
    '[User Management User Info] Set Is Form Valid',
    props<{ isFormValid: boolean }>()
);

export const saveApplicationUserDetail = createAction(
    '[User Management] Save Application User Detail',
    props<{ submitData: ApplicationUserDetail }>()
);

export const addRacf = createAction(
    '[User Management Racfs] Add Racf',
    props<{ racf: AddEditRacf }>()
);

export const deleteRacf = createAction(
    '[User Management Racfs] Delete Racf',
    props<{ racf: AddEditRacf }>()
);

export const editRacf = createAction(
    '[User Management Racfs] Edit Racf',
    props<{ racf: AddEditRacf }>()
);

export const toggleFieldTeams = createAction(
    '[User Management Teams] Toggle Field Teams',
    props<{ selected: boolean; team: string }>()
);

export const resetUserSecurityStamp = createAction(
    '[User Management] Reset User Security Stamp',
    props<{ userId: number }>()
);

export const addAssignedCustomer = createAction(
    '[User Management AssignedCustomer] Add AssignedCustomer',
    props<{ assignedCustomer: CustomerUserAgent }>()
);

export const deleteAssignedCustomer = createAction(
    '[User Management AssignedCustomer] Delete AssignedCustomer',
    props<{ assignedCustomer: CustomerUserAgent }>()
);
